import {GetterTree} from 'vuex'
import Project from "../ts/ProjectInterface";
import Filter from "../ts/Filter";

export const getters: GetterTree<any, any> = {

    /**
     * Get projects filtered by status
     *
     * @param state
     * @param getters
     * @param rootState
     * @returns {Object}
     */

    getFilteredProjects: (state, getters, rootState) => {

        let activeFilters: Array<Filter> = [];

        state.activeTableFilters.forEach((filter: Filter) => {
            if (filter.model) activeFilters.push(filter);
        });

        if (activeFilters.length===0) return state.projects;

        let projects: Array<Project> = state.projects;

        activeFilters.forEach((filter: Filter) => {

            // Mine filter
            if (filter.type==="mine") {
                projects = projects.filter((project: Project) => {
                    return project.created_by.id === rootState.user.id;
                });
            }

            // Responsible filter
            if (filter.type==="responsible") {
                projects = projects.filter((project: Project) => {
                    return project.created_by.id === rootState.user.id ||
                        (project.assistant_manager && project.assistant_manager.id === rootState.user.id);
                });
            }

            // Others filter
            if (filter.type==="others") {
                projects = projects.filter((project: Project) => {
                    return project.created_by.id !== rootState.user.id;
                });
            }

            // Status filter
            if (filter.type==="online") {
                projects = projects.filter((project: Project) => {
                    return project.status === "online";
                });
            }

            // Status filter
            if (filter.type==="offline") {
                projects = projects.filter((project: Project) => {
                    return project.status === "offline";
                });
            }

            if (filter.type==="closed") {
                // Status filter
                projects = projects.filter((project: Project) => {
                    return project.status === "closed";
                });
            }
        });

        return projects;
    },

    /**
     * Find project from loaded projects
     *
     * @param state
     * @param getters
     * @param rootState
     * @param rootGetters
     */

    findProject: (state, getters, rootState, rootGetters) => (id: number) => {

        return state.projects.find((project: Project) => {
            return project.id === id;
        });
    }
}
